<!--关于e课堂 Sag 2020-03-26-->
<template>
  <div class="its-about-e-class">
    <div class="its-image its-image-bg-1"></div>
    <div class="its-image its-image-bg-2"></div>
    <class-title class="its-about-e-class-title" :title="item.title"></class-title>
    <div class="its-about-e-class-desc" v-html="item.desc"></div>
  </div>
</template>
<script>
import ClassTitle from '../../home/components/ClassTitle'
export default {
  name: 'AboutEClass',
  components: {
    ClassTitle
  },
  props: {
    item:{
      type: Object,
      default: function(){
        return {}
      }
    }
  }
}
</script>
<style scoped>
.its-about-e-class{
  width: 1070px;
  margin: 195px auto 0 auto;
  position: relative;
}
.its-about-e-class-desc{
  margin-top: 65px;
}
.its-about-e-class-desc>>>.its-about-intro-item{
  text-indent:36px;
  font-size: 18px;
  color: #3F466A;
  font-family:PingFang SC;
  font-weight:500;
  line-height: 36px;
  text-align: justify;
}
.its-about-e-class-desc>>>.its-about-intro-item .its-strong{
  color: #3F466A;
  font-size: 24px;
}
.its-image{
  position: absolute;
  background-repeat: no-repeat;
}
.its-image-bg-1{
  background-image: url(../../../../../public/images/about_e_class_bg1.png);
  right: -165px;
  top: -60px;
  width: 160px;
  height: 152px;
}
.its-image-bg-2{
  background-image: url(../../../../../public/images/about_e_class_bg2.png);
  left: -258px;
  top: 306px;
  width: 214px;
  height: 127px;
}
</style>